var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "account" },
    [
      _vm.initialized && _vm.isLoggedIn
        ? [
            _c("div", { staticClass: "divider" }, [
              _c("div", { staticClass: "divider__left" }, [
                _c(
                  "div",
                  { staticClass: "account__header insicht insicht--fade-in" },
                  [
                    _c("span", {
                      staticClass: "account__header-title",
                      domProps: { innerHTML: _vm._s(_vm.$t("account.title")) },
                    }),
                    _vm._v(" "),
                    _c("h1", {
                      staticClass: "account__header-name",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.accountUserDetail.firstName +
                            " " +
                            _vm.accountUserDetail.lastName
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("Button", {
                      staticClass: "account__header-logout",
                      attrs: {
                        type: "button",
                        level: "tertiary",
                        text: _vm.$t("account.logoutButton"),
                        arrow: "",
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.onLogout.apply(null, arguments)
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("ul", { staticClass: "account__header-points" }, [
                      _c("li", { staticClass: "account__header-points-item" }, [
                        _c("span", {
                          staticClass: "account__header-points-value",
                          domProps: {
                            innerHTML: _vm._s(_vm.accountClub.pointsTotal),
                          },
                        }),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "account__header-points-label",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("account.kangaroo.pointsTotal")
                            ),
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "account__header-points-item" }, [
                        _c("span", {
                          staticClass: "account__header-points-value",
                          domProps: {
                            innerHTML: _vm._s(_vm.accountClub.points),
                          },
                        }),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "account__header-points-label",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("account.kangaroo.pointsAvailable")
                            ),
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("ul", { staticClass: "account__header-points" }, [
                      _c("li", { staticClass: "account__header-points-item" }, [
                        _c("span", {
                          staticClass: "account__header-points-value",
                          domProps: {
                            innerHTML: _vm._s(_vm.accountReferralCount),
                          },
                        }),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "account__header-points-label",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("account.referral.referralCount")
                            ),
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "account__header-block" }, [
                      _c("h2", {
                        staticClass: "account__header-block-title",
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("account.emailTitle")),
                        },
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "account__header-block-text",
                        domProps: {
                          innerHTML: _vm._s(_vm.accountUserDetail.email),
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "account__header-block" },
                      [
                        _c("h2", {
                          staticClass: "account__header-block-title",
                          domProps: {
                            innerHTML: _vm._s(_vm.$t("account.addressTitle")),
                          },
                        }),
                        _vm._v(" "),
                        _vm.formattedAddress
                          ? _c("address", {
                              staticClass: "account__header-block-text",
                              domProps: {
                                innerHTML: _vm._s(_vm.formattedAddress),
                              },
                            })
                          : _c("div", {
                              staticClass: "account__header-block-text",
                              domProps: {
                                innerHTML: _vm._s(_vm.$t("account.noAddress")),
                              },
                            }),
                        _vm._v(" "),
                        _c("Button", {
                          staticClass: "account__edit-button",
                          attrs: {
                            type: "button",
                            level: "tertiary",
                            text: _vm.$t("account.addressEdit.edit"),
                            arrow: "",
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.onAddressEdit.apply(null, arguments)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "account__header-block" },
                      [
                        _c("h2", {
                          staticClass: "account__header-block-title",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("account.passwordResetTitle")
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "account__header-block-text",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$t("account.passwordResetText")
                            ),
                          },
                        }),
                        _vm._v(" "),
                        _c("Button", {
                          staticClass: "account__edit-button",
                          attrs: {
                            type: "button",
                            level: "tertiary",
                            text: _vm.$t("account.passwordResetButton"),
                            arrow: "",
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.onPasswordChange.apply(null, arguments)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.accountUserDetail.groups &&
                    _vm.accountUserDetail.groups.length
                      ? _c("div", { staticClass: "account__header-block" }, [
                          _c("h2", {
                            staticClass: "account__header-block-title",
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("account.groupsTitle")),
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "ul",
                            { staticClass: "account__groups-list" },
                            _vm._l(
                              _vm.accountUserDetail.groups,
                              function (group, index) {
                                return _c("li", {
                                  key: index + "-" + group.name,
                                  staticClass: "account__groups-item",
                                  domProps: { innerHTML: _vm._s(group.name) },
                                })
                              }
                            ),
                            0
                          ),
                        ])
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "divider__right" },
                [
                  _c("a", { staticClass: "anchor", attrs: { id: "points" } }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "account__block insicht insicht--fade-in" },
                    [
                      _c("div", { staticClass: "account__points" }, [
                        _c("div", { staticClass: "account__points-wrapper" }, [
                          _c(
                            "div",
                            { staticClass: "account__points-header" },
                            [
                              _c(
                                "div",
                                { staticClass: "account__points-level" },
                                [
                                  _c("div", {
                                    staticClass: "account__points-level-label",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$t("account.kangaroo.currentLevel")
                                      ),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "account__points-level-name",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.accountClub.tierLevel
                                      ),
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c("Button", {
                                staticClass: "account__points-header-link",
                                attrs: {
                                  type: "button",
                                  level: "tertiary",
                                  text: _vm.$t(
                                    "account.kangaroo.levelLinkText"
                                  ),
                                  href: _vm.$t("account.kangaroo.levelLinkUrl"),
                                  arrow: "",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "account__points-progress" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "account__points-progress-step",
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "account__points-progress-value",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.accountClub.pointsTotal
                                      ),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "account__points-progress-label",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$t("account.kangaroo.pointsTotal")
                                      ),
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "account__points-progress-step",
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "account__points-progress-value",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.accountClub.pointsToNext
                                      ),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "account__points-progress-label",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$t("account.kangaroo.pointsToNext")
                                      ),
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "account__points-progress-step",
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "account__points-progress-level",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.accountClub.nextTierLevel ||
                                          _vm.accountClub.tierLevel
                                      ),
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.accountClaimableCoupons.length
                    ? [
                        _c("a", {
                          staticClass: "anchor",
                          attrs: { id: "rewards" },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "account__block insicht insicht--fade-in",
                          },
                          [
                            _c("h2", {
                              staticClass: "account__block-title",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("account.kangaroo.rewardsTitle")
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "account__block-text",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("account.kangaroo.rewardsText")
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _vm.redeemResponse.message
                              ? _c("GeneralMessage", {
                                  attrs: {
                                    message: _vm.redeemResponse.message,
                                    type: _vm.redeemResponse.type,
                                  },
                                  on: {
                                    close: function ($event) {
                                      _vm.redeemResponse.message = ""
                                    },
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "content-slider" },
                              [
                                _c(
                                  "vue-glide",
                                  _vm._b(
                                    {
                                      ref: "glide",
                                      staticClass: "account__claimable-coupons",
                                    },
                                    "vue-glide",
                                    _vm.glideOptions,
                                    false
                                  ),
                                  _vm._l(
                                    _vm.accountClaimableCoupons,
                                    function (coupon) {
                                      return _c(
                                        "vue-glide-slide",
                                        {
                                          key: coupon.code,
                                          staticClass:
                                            "account__claimable-coupon",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "media-container media-container--ratio-4-3",
                                            },
                                            [
                                              _c("img", {
                                                staticClass:
                                                  "account__claimable-coupon-image",
                                                attrs: {
                                                  src: coupon.image,
                                                  alt: "Coupon Image",
                                                  "data-object-fit": "",
                                                  loading: "lazy",
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("Button", {
                                            staticClass:
                                              "account__claimable-coupon-button",
                                            attrs: {
                                              level: "primary",
                                              text: _vm.$t(
                                                "account.kangaroo.coupons.redeem",
                                                { points: coupon.points }
                                              ),
                                              disabled: !coupon.eligible,
                                              variants: ["block", "small"],
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.redeemCoupon(coupon)
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("h3", {
                                            staticClass:
                                              "account__claimable-coupon-title",
                                            domProps: {
                                              innerHTML: _vm._s(coupon.label),
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass:
                                              "account__claimable-coupon-subtitle",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$t(
                                                  "account.kangaroo.coupons.storeCredit",
                                                  {
                                                    value: _vm.formatDiscount(
                                                      coupon.amount
                                                    ),
                                                    points: coupon.points,
                                                  }
                                                )
                                              ),
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c("a", {
                    staticClass: "anchor",
                    attrs: { id: "discounts" },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "account__block insicht insicht--fade-in" },
                    [
                      _c("h2", {
                        staticClass: "account__block-title",
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("account.couponsTitle")),
                        },
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "account__block-text",
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("account.couponsText")),
                        },
                      }),
                      _vm._v(" "),
                      _vm.accountCoupons.length
                        ? _c(
                            "table",
                            { staticClass: "account__coupons" },
                            _vm._l(
                              _vm.accountCoupons,
                              function (coupon, index) {
                                return _c(
                                  "tr",
                                  {
                                    key: "coupon-" + index,
                                    staticClass: "account__coupon",
                                  },
                                  [
                                    _c(
                                      "td",
                                      { staticClass: "account__coupon-cell" },
                                      [
                                        _c("span", {
                                          staticClass: "account__coupon-value",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.$t("account.couponDiscount", {
                                                value: _vm.formatDiscount(
                                                  coupon.discount
                                                ),
                                              })
                                            ),
                                          },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "account__coupon-cell" },
                                      [
                                        _c("i18n", {
                                          staticClass: "account__coupon-code",
                                          attrs: {
                                            path: "account.couponCode",
                                            tag: "span",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "code",
                                                fn: function () {
                                                  return [
                                                    _c("span", {
                                                      staticClass:
                                                        "account__coupon-code-value",
                                                      domProps: {
                                                        innerHTML: _vm._s(
                                                          coupon.code
                                                        ),
                                                      },
                                                    }),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          )
                        : _c("h3", {
                            staticClass: "account__block-text",
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("account.noCoupons")),
                            },
                          }),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.hasFeature("FEATURE_REFERRAL") && _vm.accountReferralUrl
                    ? _c("a", {
                        staticClass: "anchor",
                        attrs: { id: "referral" },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasFeature("FEATURE_REFERRAL") && _vm.accountReferralUrl
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "account__block insicht insicht--fade-in",
                        },
                        [
                          _c("h2", {
                            staticClass: "account__block-title",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("account.referral.title")
                              ),
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "account__referral" }, [
                            _c(
                              "div",
                              { staticClass: "account__referral-image" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "media-container media-container--ratio-4-3",
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: _vm.referralImage.src,
                                        srcset: _vm.referralImage.srcset,
                                        alt: "Referral Image",
                                        "data-object-fit": "",
                                        loading: "lazy",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "account__referral-content" },
                              [
                                _c("div", {
                                  staticClass: "account__block-text",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t("account.referral.text")
                                    ),
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "account__referral-token",
                                  domProps: {
                                    innerHTML: _vm._s(_vm.accountReferralUrl),
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.onReferralTokenClick.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("Button", {
                                  attrs: {
                                    level: "primary",
                                    text: _vm.$t(
                                      "account.referral.whatsappButton"
                                    ),
                                    icon: "whatsapp",
                                    href: _vm.whatsappShare(),
                                    target: "_blank",
                                    variants: ["small"],
                                  },
                                }),
                                _vm._v(" "),
                                _c("Button", {
                                  attrs: {
                                    level: "primary",
                                    icon: "envelope",
                                    text: _vm.$t(
                                      "account.referral.emailButton"
                                    ),
                                    href: _vm.emailShare(),
                                    variants: ["small"],
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("a", { staticClass: "anchor", attrs: { id: "orders" } }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "account__block insicht insicht--fade-in" },
                    [
                      _c("h2", {
                        staticClass: "account__block-title",
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("account.ordersTitle")),
                        },
                      }),
                      _vm._v(" "),
                      _vm.lastOrders.length
                        ? _c("div", { staticClass: "account__orders" }, [
                            _c(
                              "table",
                              { staticClass: "account__orders-table" },
                              [
                                _c(
                                  "tr",
                                  { staticClass: "account__orders-header" },
                                  [
                                    _c("th", {
                                      staticClass: "account__orders-header-col",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t("account.orderDate")
                                        ),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("th", {
                                      staticClass: "account__orders-header-col",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t("account.orderTotal")
                                        ),
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.lastOrders, function (order) {
                                  return _c(
                                    "tr",
                                    {
                                      key: order.token,
                                      staticClass: "account__orders-row",
                                    },
                                    [
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "account__orders-row-col",
                                        },
                                        [
                                          _c("a", {
                                            attrs: {
                                              href: order.url,
                                              target: "_blank",
                                            },
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.formatDate(
                                                  order.checkoutCompletedAt
                                                )
                                              ),
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("td", {
                                        staticClass: "account__orders-row-col",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$options.filters.madpricecent(
                                              order.total,
                                              "html"
                                            )
                                          ),
                                        },
                                      }),
                                    ]
                                  )
                                }),
                              ],
                              2
                            ),
                          ])
                        : _c("h3", {
                            staticClass: "account__block-text",
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("account.noOrders")),
                            },
                          }),
                    ]
                  ),
                ],
                2
              ),
            ]),
          ]
        : _vm.initialized && !_vm.isLoggedIn
        ? _c(
            "div",
            { staticClass: "account__wrapper insicht insicht--fade-in" },
            [
              _c(
                "div",
                { staticClass: "text-block text-block--center" },
                [
                  _c("h1", {
                    staticClass: "text-block__title",
                    domProps: {
                      innerHTML: _vm._s(_vm.$t("account.notLoggedIn.title")),
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-block__text" }, [
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(_vm.$t("account.notLoggedIn.text")),
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("Button", {
                    attrs: {
                      level: "primary",
                      text: _vm.$t("account.notLoggedIn.button"),
                    },
                    on: { click: _vm.onLogin },
                  }),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "userDetailModal",
          attrs: {
            "overlay-type": "user-detail-edit",
            "html-classes": ["hide--header", "show--modal"],
            narrow: "",
            "soft-close": "",
          },
          on: { softclose: _vm.onUserDetailEditSoftClose },
        },
        [
          _c("OverlayUserDetailEdit", {
            ref: "overlayUserDetailEdit",
            on: { close: _vm.onUserDetailEditClose },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "addressModal",
          attrs: {
            "overlay-type": "address-edit",
            "html-classes": ["hide--header", "show--modal"],
            narrow: "",
            "soft-close": "",
          },
          on: { softclose: _vm.onAddressEditSoftClose },
        },
        [
          _c("OverlayAddressEdit", {
            ref: "overlayAddressEdit",
            on: { close: _vm.onAddressEditClose },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "passwordModal",
          attrs: {
            "overlay-type": "password-change",
            "html-classes": ["hide--header", "show--modal"],
            narrow: "",
            "soft-close": "",
          },
          on: { softclose: _vm.onPasswordChangeSoftClose },
        },
        [
          _c(
            "div",
            { staticClass: "overlay-dialog" },
            [_c("FormPasswordReset", { ref: "passwordChange" })],
            1
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }